import {
  IconArchive,
  IconBuilding,
  IconCamera,
  IconClipboardList,
  IconFileInvoice,
  IconFileText,
  IconFolder,
  IconLicense,
  IconReceipt,
  IconScale,
  IconShield,
  IconTool,
  IconUsers,
  type Icon,
} from '@tabler/icons-react';

type Rule = {
  keywords: readonly string[];
  icon: Icon;
};

const RULES: readonly Rule[] = [
  { keywords: ['facture', 'compta'], icon: IconReceipt },
  { keywords: ['assurance'], icon: IconShield },
  { keywords: ['impôt', 'impot', 'taxe'], icon: IconFileText },
  { keywords: ['travaux', 'maintenance'], icon: IconTool },
  { keywords: ['photo'], icon: IconCamera },
  { keywords: ['officiel', 'acte'], icon: IconLicense },
  { keywords: ['famille'], icon: IconUsers },
  {
    keywords: ['décision', 'decision', 'pv', 'ag', 'réunion', 'reunion'],
    icon: IconClipboardList,
  },
  { keywords: ['indivision'], icon: IconScale },
  { keywords: ['société', 'societe', 'sci', 'sarl'], icon: IconBuilding },
  { keywords: ['archive'], icon: IconArchive },
  { keywords: ['devis'], icon: IconFileInvoice },
];

export const getDirectoryIcon = (name: string): Icon => {
  const normalized = name.toLowerCase().trim();

  for (const rule of RULES) {
    if (rule.keywords.some(keyword => normalized.includes(keyword))) {
      return rule.icon;
    }
  }

  return IconFolder;
};
